import React from 'react';
import { observer } from 'mobx-react';
import { CampaignTypeStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class CampaignTypeCreate extends React.Component {

  onCreate = name => {
    CampaignTypeStore.create({data: {name}}, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default CampaignTypeCreate;
